export default {
	namespaced: true,

	state: {
		isMobile: false,
		isCollapsed: false,
		printMode: false,
		loading: 0,
		customerPicker: false
	},

	mutations: {
		SET_MOBILE(state, isMobile) {
			state.isMobile = isMobile;
		},

		SET_COLLAPSED(state, isCollapsed) {
			state.isCollapsed = isCollapsed;
		},

		SET_PRINTMODE(state, mode) {
			state.printMode = mode;
		},

		SET_LOADING(state, loading) {
			state.loading += loading;
		},

		SET_CUSTOMER_PICKER(state, value) {
			state.customerPicker = value;
		}
	},

	actions: {
		setMobileState({ commit }, isMobile) {
			commit('SET_MOBILE', isMobile);
		},

		toggleCollapsed({ state, commit }) {
			commit('SET_COLLAPSED', !state.isCollapsed);
		},

		setPrintMode({ commit }, mode) {
			commit('SET_PRINTMODE', mode);
		},

		setLoading({ commit }, loading) {
			commit('SET_LOADING', loading);
		},

		setCustomerPicker({commit}, value) {
			commit('SET_CUSTOMER_PICKER', value);
		}
	},

	getters: {
		getCustomerPicker(state) {
			return state.customerPicker;
		},

		isMobile: state => {
			return state.isMobile;
		},
		isCollapsed: state => {
			return state.isCollapsed;
		},
		printMode: state => {
			return state.printMode;
		},
		loading: state => {
			return state.loading;
		}
	}
};
